import { Box, Button } from '@mui/material';
import { forwardRef } from 'react';

import { ClickHandler } from '../../utils/clickEvent';
import { Children, Component, ReturnComponent, SxStyle } from '../../utils/reactTypes';
import { ConditionalTooltip } from '../utils/conditionalComponents';

export const AxleButton = forwardRef(
    (
        {
            children,
            onClick = undefined,
            startIcon = undefined,
            disabled = false,
            tooltipWhenDisabled = '',
            size = 'medium',
            color = 'primary',
            className = '',
            variant = 'contained',
            wrap = true,
            sx = {},
            ...rest
        }: {
            children: Children;
            onClick?: ClickHandler;
            startIcon?: Component | undefined;
            disabled?: boolean;
            tooltipWhenDisabled?: string;
            wrap?: boolean;
            size?: 'small' | 'medium' | 'large';
            color?: 'primary' | 'secondary';
            className?: string; // TODO: Deprecate this property.
            variant?: 'text' | 'outlined' | 'contained'; // TODO: Deprecate this property.
            sx?: SxStyle;
        },
        ref,
    ): ReturnComponent => {
        return (
            <Box
                className={className}
                // TODO: Can we get rid of this?
                sx={{
                    position: 'relative',
                    ...sx,
                }}
                // We need the forwardRef and the {...rest} props to make the button work with
                //  a surrounding <Tooltip> component. See: https://github.com/mui/material-ui/issues/21324#issuecomment-639830442
                ref={ref}
                {...rest}
            >
                <ConditionalTooltip title={tooltipWhenDisabled} condition={disabled}>
                    {/* This <Box/> wrapper is necessary as <Tooltip/> doesn’t work when directly
                        applied to a button if the button is disabled. */}
                    <Box>
                        <Button
                            onClick={onClick}
                            startIcon={startIcon}
                            variant={variant}
                            color={color}
                            disabled={disabled}
                            size={size}
                            sx={{
                                whiteSpace: wrap ? undefined : 'nowrap',
                                lineHeight: '1.5em',
                            }}
                        >
                            {/* Without this <Box/> wrapper, the children get affected by the horizontal
                                 inline-flex layout of the Button component. */}
                            <Box>{children}</Box>
                        </Button>
                    </Box>
                </ConditionalTooltip>
            </Box>
        );
    },
);
AxleButton.displayName = 'AxleButton';
